import type Parse from 'parse';

import { AssetType } from '@telespot/domain';

import { ParseMapper } from '../../parse.mapper';
import { ObjectTopology, SoftDeletableTopology } from '../../parse.topology';
import { DeviceTypeTopology } from '../acquisition';

export enum AssetTypeTopology {
  TABLE = 'AssetType',
  NAME = 'name',
  DESCRIPTION = 'description',
  TYPE = 'type',
  VERSION = 'version',
  DEVICETYPE = 'deviceType',
}

export class ParseAssetTypeMapper extends ParseMapper {
  public toDomain(parseObject: Parse.Object): AssetType {
    const deviceTypes = parseObject.get(AssetTypeTopology.DEVICETYPE) || [];
    return new AssetType({
      id: parseObject.id,
      name: parseObject.get(AssetTypeTopology.NAME),
      description: parseObject.get(AssetTypeTopology.DESCRIPTION),
      type: parseObject.get(AssetTypeTopology.TYPE),
      version: parseObject.get(AssetTypeTopology.VERSION),
      deviceTypeIds: deviceTypes.map((dt: Parse.Object) => dt.id),
      createdAt: parseObject.get(ObjectTopology.CREATED_AT),
      updatedAt: parseObject.get(ObjectTopology.UPDATED_AT),
      deletedAt: parseObject.get(SoftDeletableTopology.DELETED_AT),
    });
  }

  public fromDomain(assetType: AssetType): Parse.Object {
    const parseDeviceTypes = assetType.deviceTypeIds.map((deviceTypeId) =>
      this.subclasses.getSubclass(DeviceTypeTopology.TABLE).createWithoutData(deviceTypeId)
    );

    const parseObject = this.parse.Object.fromJSON({
      className: AssetTypeTopology.TABLE,
      [ObjectTopology.ID]: assetType.id,
      [ObjectTopology.CREATED_AT]: assetType.createdAt,
      [ObjectTopology.UPDATED_AT]: assetType.updatedAt,
    });

    parseObject.set({
      [SoftDeletableTopology.DELETED_AT]: assetType.deletedAt,
      [AssetTypeTopology.NAME]: assetType.name,
      [AssetTypeTopology.DESCRIPTION]: assetType.description,
      [AssetTypeTopology.TYPE]: assetType.type,
      [AssetTypeTopology.VERSION]: assetType.version,
      [AssetTypeTopology.DEVICETYPE]: parseDeviceTypes,
    });

    return parseObject;
  }
}
